import { render, staticRenderFns } from "./ProductListCart.vue?vue&type=template&id=05879da3&lang=html&"
import script from "./ProductListCart.vue?vue&type=script&lang=js&"
export * from "./ProductListCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports